import { Actions, ActionTypes } from '@appStore/help/actions';
import { UserGuide } from '@model';

export interface State {
  loading: boolean;
  loaded: boolean;
  userGuides: UserGuide[];
}

export const initialState: State = {
  loading: false,
  loaded: false,
  userGuides: []
};

export function reducer(state = initialState, action: Actions): State {
  switch (action.type) {
    case ActionTypes.UserGuidesLoad:
      return { ...state, loaded: false, loading: true };

    case ActionTypes.UserGuidesLoadSuccess:
      return { ...state, loaded: true, loading: false, userGuides: action.payload };

    case ActionTypes.UserGuidesLoadFail:
      return { ...state, loaded: false, loading: false };

    case ActionTypes.GuideSetAsRead:
      return { ...state, loaded: false, loading: true };

    case ActionTypes.GuideSetAsReadSuccess:
      if (state.userGuides.length === 0) {
        return { ...state, loaded: true, loading: false, userGuides: [action.payload] };
      }

      let newUserGuideList = state.userGuides.map(ug => {
        if (ug.id === action.payload.id) {
          return action.payload;
        }
        return ug;
      });

      return { ...state, loaded: true, loading: false, userGuides: newUserGuideList };

    case ActionTypes.GuideSetAsReadFail:
      return { ...state, loaded: false, loading: false };
  }
  return state;
}

export const _getAllUserGuides = (state: State) => state.userGuides;
export const _getUserGuidesLoaded = (state: State) => state.loaded;
export const _getUserGuidesLoading = (state: State) => state.loading;
